import { Button } from "../ds2/components/Button";
import { WazToolbar } from "../components/wazawan/toolbar/WazToolbar";
import { Trash } from "lucide-react";
import { isEmptyObject } from "@tiptap/core";
import "./DesignSystem.css";
import { Icon } from "./components/Icon";

export const DesignSystem = () => {
    return (
        <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
            <WazToolbar />

            <div style={{ display: "flex", flexDirection: "column", padding: "32px", gap: "16px"}}>
                <h1>Design System</h1>

                <h2>Buttons</h2>
                <Button size="md" variant="primary">Primary</Button>
                <Button size="md" variant="secondary">Secondary</Button>
                <Button size="md" variant="tertiary">Tertiary</Button>
                <Button size="md" variant="primary" leftIcon={<Trash />}>Left Icon</Button>
                <Button size="md" variant="primary" rightIcon={<Trash />}>Right Icon</Button>
                <Button size="md" variant="primary" leftIcon={<Trash />} rightIcon={<Trash />}>L & R</Button>
                <Button size="md" variant="primary" disabled>Disabled P</Button>
                <Button size="sm" variant="primary" >Small</Button>
                <Button size="md" variant="primary" >Medium</Button>
                <Button size="lg" variant="primary" >Large</Button>


                <h2>Cards</h2>
                <div className="ds2-card">
                    Card body
                </div>

                <h2>Icons</h2>
                <Icon icon={<Trash />} />
                <Icon icon={<Trash />} variant="secondary" />
                <Icon icon={<Trash />} variant="tertiary" />
                <Icon icon={<Trash />} variant="primary" size="sm" />
                <Icon icon={<Trash />} variant="primary" size="md" />
                <Icon icon={<Trash />} variant="primary" size="lg" />
                <Icon icon={<Trash />} variant="primary" size="sm" border={true} />
                <Icon icon={<Trash />} variant="primary" size="md" border={true} />
                <Icon icon={<Trash />} variant="primary" size="lg" border={true} />
            </div>
        </div>
    );
};